@if (userService.currentUser$ | async) {
  <form class="component-content" [formGroup]="topicRequestForm">
    <div class="text-container">
      <span class="font-medium-display-small">Hast Du einen Themenwunsch?</span>
      <span class="font-medium-title-large text-align-center">
        Deine Meinung zählt!
      </span>
      <span class="font-regular-body-large text-align-center">
        Wir wollen wissen, welche Fortbildungsthemen Dich brennend
        interessieren.
        <br />
        Hilf uns, unser Programm noch besser auf Deine Bedürfnisse abzustimmen.
        <br />
        Wir freuen uns auf Deine Anregungen und Vorschläge!
      </span>
    </div>
    <div class="input-simple">
      <input
        id="topicname"
        type="text"
        formControlName="topic"
        class="input-field"
        placeholder="Wunschthema" />
    </div>
    @if (!userService.currentUser$.value) {
      <div class="flex-c gap-4">
        <div
          class="flex-r align-center gap-8 align-self-stretch"
          [class.invalid-checkbox]="
            topicRequestForm.get('privacyConfirmation').invalid &&
            topicRequestForm.get('privacyConfirmation').touched
          ">
          <div class="inwi-checkbox">
            <input
              id="privacyConfirmation"
              type="checkbox"
              name="privacyConfirmation"
              formControlName="privacyConfirmation" />
          </div>
          <div class="flex-c align-start gap-4 flex-1-0-0">
            <label for="agb" class="font-regular-body-large">
              Hiermit bestätige ich meine Kenntnis von den
              <a
                class="font-color-black"
                href="/privacy-policy"
                target="_blank">
                Datenschutzinformationen </a
              >.
            </label>
          </div>
        </div>
        @if (
          topicRequestForm.get('privacyConfirmation').invalid &&
          topicRequestForm.get('privacyConfirmation').touched
        ) {
          <div class="inwi-error-container show-overflow">
            <div class="inwi-text-error font-regular-label-large">
              Sie müssen die Datenschutzinformationen akzeptieren.
            </div>
          </div>
        }
      </div>
    }
    <button
      class="inwi-text-button-large-primary"
      (click)="submit()"
      [disabled]="isLoading">
      <div class="button-content">
        <div class="button-text">Themenwunsch stellen</div>
      </div>
    </button>
  </form>
}
